import React from 'react';
import { StaticPageLayout } from '../StaticPageLayout';
import styles from '../StaticPageLayout.module.scss';

interface ComingSoonProps {
  title: string;
  emoji?: string;
  message?: string;
}

export const ComingSoonPage: React.FC<ComingSoonProps> = ({ 
  title, 
  emoji = "🚧", 
  message = "We're working hard to bring you this feature. Stay tuned!" 
}) => {
  return (
    <StaticPageLayout>
      <div className={styles.comingSoonContainer}>
        <div className={styles.emoji}>{emoji}</div>
        <h2>{title}</h2>
        <p>{message}</p>
      </div>
    </StaticPageLayout>
  );
};

